@import '../../../theme.scss';

verdocs-portal {
}
